var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDefaultAvatar = function SvgDefaultAvatar(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_327",
    "data-name": "Group 327",
    transform: "translate(-156 -207)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    cx: 51,
    cy: 51,
    r: 51,
    transform: "translate(156 207)",
    fill: "#d6d6d6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_325",
    "data-name": "Group 325",
    transform: "translate(495.373 862.577)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M-288.278-497.588a22.1,22.1,0,0,0-22.1,22.1v11.048h44.19v-11.048A22.1,22.1,0,0,0-288.278-497.588Z",
    transform: "translate(0 -106.762)",
    fill: "rgba(0,0,0,0.16)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_33",
    "data-name": "Ellipse 33",
    cx: 14.788,
    cy: 14.788,
    r: 14.788,
    transform: "translate(-303.066 -638.161)",
    fill: "rgba(0,0,0,0.16)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDefaultAvatar);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDIiIGhlaWdodD0iMTAyIiB2aWV3Qm94PSIwIDAgMTAyIDEwMiI+CiAgPGcgaWQ9Ikdyb3VwXzMyNyIgZGF0YS1uYW1lPSJHcm91cCAzMjciIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNTYgLTIwNykiPgogICAgPGNpcmNsZSBpZD0iRWxsaXBzZV8zMiIgZGF0YS1uYW1lPSJFbGxpcHNlIDMyIiBjeD0iNTEiIGN5PSI1MSIgcj0iNTEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE1NiAyMDcpIiBmaWxsPSIjZDZkNmQ2Ii8+CiAgICA8ZyBpZD0iR3JvdXBfMzI1IiBkYXRhLW5hbWU9Ikdyb3VwIDMyNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDk1LjM3MyA4NjIuNTc3KSI+CiAgICAgIDxwYXRoIGlkPSJQYXRoXzUwNCIgZGF0YS1uYW1lPSJQYXRoIDUwNCIgZD0iTS0yODguMjc4LTQ5Ny41ODhhMjIuMSwyMi4xLDAsMCwwLTIyLjEsMjIuMXYxMS4wNDhoNDQuMTl2LTExLjA0OEEyMi4xLDIyLjEsMCwwLDAtMjg4LjI3OC00OTcuNTg4WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAtMTA2Ljc2MikiIGZpbGw9InJnYmEoMCwwLDAsMC4xNikiLz4KICAgICAgPGNpcmNsZSBpZD0iRWxsaXBzZV8zMyIgZGF0YS1uYW1lPSJFbGxpcHNlIDMzIiBjeD0iMTQuNzg4IiBjeT0iMTQuNzg4IiByPSIxNC43ODgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zMDMuMDY2IC02MzguMTYxKSIgZmlsbD0icmdiYSgwLDAsMCwwLjE2KSIvPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";